import { LanguageContextType } from "~/context/LanguageContext";

export const SITE_URL = "https://skillsynergy.net";

export const CURRENT_OFFER = "20";

export const COUNTRIES_USING_EURO = [
  "at", // Austria
  "be", // Belgium
  "cy", // Cyprus
  "de", // Germany
  "ee", // Estonia
  "es", // Spain
  "fi", // Finland
  "fr", // France
  "gr", // Greece
  "ie", // Ireland
  "it", // Italy
  "lt", // Lithuania
  "lu", // Luxembourg
  "lv", // Latvia
  "mt", // Malta
  "nl", // Netherlands
  "pt", // Portugal
  "si", // Slovenia
  "sk", // Slovakia
];

export const ALGERIA = "dz"; // Use DZD

export const SUPPORTED_LANGUAGES: LanguageContextType["lang"][] = [
  "en", // English
  "fr", // French
  "de", // German
  "ar", // Arabic
];

export const DEFAULT_LANGUAGE: LanguageContextType["lang"] = "en";

export const CONTACT_EMAIL = "contact@skillsynergy.net";
export const CONTACT_PHONE = "+49 151 525 54041";
export const CONTACT_PHONE_E164 = "+4915152554041";
export const CONTACT_CITY = "Berlin, Germany";

export const LINKED_IN_URL = "https://www.linkedin.com/company/skillsynergy";
export const X_URL = "https://x.com/SkillSynergyNet";
export const YOUTUBE_URL = "https://www.youtube.com/@SkillSynergyDotNet";
export const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61559837181591";

export const SOCIAL_LINKS = [
  { abbr: "in", label: "LinkedIn", url: LINKED_IN_URL },
  { abbr: "X", label: "X", url: X_URL },
  { abbr: "YT", label: "YouTube", url: YOUTUBE_URL },
  { abbr: "f", label: "Facebook", url: FACEBOOK_URL },
];

export const YOUTUBE_INTRODUCTION_VIDEO_ID = "ens-KF0NxkQ";
export const DZ_YOUTUBE_INTRODUCTION_VIDEO_ID = "HEal7fGuQYs";
